import { render, staticRenderFns } from "./statistics-list.vue?vue&type=template&id=d5eda2b6&scoped=true&"
import script from "./statistics-list.vue?vue&type=script&lang=js&"
export * from "./statistics-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5eda2b6",
  null
  
)

export default component.exports